import React from 'react';
import { useHistory } from "react-router-dom";
import { Bar } from 'react-chartjs-2';

function BarChart(props) {

    let history = useHistory();
    const pieChartData = props.data
    let month = props.month
    let labels = []
    let data = []
    let yStepSize = 0

    const orderListDataClick = tempData => {
        history.push({
            pathname: '/orderDetailList',
            state: { data: tempData }
        })
    }

    if (props.data) {
        data = Object.values(props.data)
        labels = Object.keys(props.data)
        var maxValue = Math.max.apply(0, data);
        yStepSize = maxValue / 4
        // let monthList = Object.keys(props.data)
        // let largest = 0

        //     labels = Object.keys(props.data)
        //     data = Object.values(props.data)
        //     labels = labels.splice(2, 7)
        //     data = data.splice(2, 7)
        //     data[2] = data[2] + data[3]

        //     for (let i = 0; i <= data.length; i++) {
        //         if (data[i] > largest) {
        //             largest = data[i];
        //         }
        //     }
        //     yStepSize = largest / 4

    }

    return (

        <div>

            <Bar
                height='190'
                data={{
                    // labels: ['Assigned', 'Shipped', 'Delivered', 'Claimed', 'Canceled', 'On Hold', 'Completed'],
                    labels: ['Delivered', 'Assigned', 'Claimed', 'On Hold', 'Completed', 'Shipped', 'Canceled'],
                    // labels: labels,
                    datasets: [

                        {
                            data: data,
                            backgroundColor: '#2B3856'
                        }
                    ],
                }}
                options={{
                    onClick: function (e) {
                        let linePoint = this.getElementAtEvent(e)[0];
                        if (linePoint) {
                            if (linePoint._index === 0) {
                                let tempdata = { ...props.stateMonth, typeOrder: 'delivered' }
                                orderListDataClick(tempdata);
                            }
                            if (linePoint._index === 1) {
                                let tempdata = { ...props.stateMonth, typeOrder: 'assigned' }
                                orderListDataClick(tempdata);
                            }
                            if (linePoint._index === 2) {
                                let tempdata = { ...props.stateMonth, typeOrder: 'claim' }
                                orderListDataClick(tempdata);
                            }
                            if (linePoint._index === 3) {
                                let tempdata = { ...props.stateMonth, typeOrder: 'hold' }
                                orderListDataClick(tempdata);
                            }
                            if (linePoint._index === 4) {
                                let tempdata = { ...props.stateMonth, typeOrder: 'complete' }
                                orderListDataClick(tempdata);
                            }
                            if (linePoint._index === 5) {
                                let tempdata = { ...props.stateMonth, typeOrder: 'shipped' }
                                orderListDataClick(tempdata);
                            }
                            if (linePoint._index === 6) {
                                let tempdata = { ...props.stateMonth, typeOrder: 'cancelled' }
                                orderListDataClick(tempdata);
                            }
                        }
                    },
                    maintainAspectRatio: false,
                    responsive: true,
                    legend: {
                        display: false,
                    },
                    scales: {
                        display: false,
                        xAxes: [{
                            gridLines: {
                                display: false,
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Status'
                            },
                            barPercentage: 0.9
                        }],
                        yAxes: [{
                            ticks: {
                                min: 0,
                                stepSize: Math.round(yStepSize),
                                callback: function (value) { if (value % 1 === 0) { return value; } }
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Count'
                            }

                        }]
                    },

                }}
            />
        </div>

    )
}

export default BarChart